export default __webpack_public_path__ + "static/media/landing_bg.fa036c25.png";